import React from 'react';
import Select , { components }from 'react-select';
import PropTypes from 'prop-types';
import { renderComponentField } from '@/shared/components/form/FormField';

const Option = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div className="select-option">
        <div className="select-option__label">
          {data.label}
        </div>

        {data.description && (
          <div className="select-option__description">
            {data.description}
          </div>
        )}
      </div>
    </components.Option>
  );
};

export const SelectField = React.forwardRef(({
  onChange, value, name, placeholder, options, isClearable, isMulti=false
}, ref) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  if(options){
    for (const [key, val] of Object.entries(options)) {
      if (val.value == value){
          value = val;
          break;
      }
    }
  }

  return (
    <Select
      name={name}
      value={value}
      onChange={handleChange}
      options={options}
      clearable={false}
      className="react-select"
      placeholder={placeholder}
      classNamePrefix="react-select"
      isClearable={isClearable}
      ref={ref}
      isMulti={isMulti}
      components={{ Option }} 
    />
  );
});

SelectField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]).isRequired,
};

SelectField.defaultProps = {
  placeholder: '',
  options: [],
};

export default renderComponentField(SelectField);
